import React, { Component } from 'react';

class Modal extends Component {
    render() {
        const modalToggleClass = !this.props.isOpen ? " opacity-0 pointer-events-none" : " opacity-1 pointer-events-all"
        const modalBoxToggleClass = !this.props.isOpen ? " -translate-y-20" : " translate-y-0"

        return (
            <div className={`fixed z-50 top-0 left-0 w-full h-full flex justify-center items-center transition duration-300${modalToggleClass}`}>
                {/* Overlay */}
                <div className={`overlay absolute top-0 left-0 w-full h-full bg-black z-10 opacity-40`} onClick={this.props.onOverlayClick} />

                {/* Modal Box */}
                <div className={`relative z-20 p-10 bg-white rounded-md transition duration-300 transform${modalBoxToggleClass}`} style={this.props.modalBoxStyle}>
                    {this.props.children}
                </div>
            </div>
        );
    }
}

class ModalTitle extends Component {
    render() {
        return (
            <h5 className="text-center text-2xl font-bold mb-5">{this.props.children}</h5>
        )
    }
}

class ModalBody extends Component {
    render() {
        return (
            <div>{this.props.children}</div>
        )
    }
}

// Compound components
Modal.Title = ModalTitle
Modal.Body = ModalBody

export default Modal;